<div
  class="card"
  *appIsGranted="['TOOLS_PROCESS_FLOW', 'TOOLS_PROCESS_FLOW', 'READ']"
>
  <div class="card-header"><h2>Fluxo de homologação</h2></div>
  <div class="card-body">
    <div class="card align-items-center" *ngIf="loading">
      <div card="card-body">
        <div class="spinner-border text-primary m-1" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <p-accordion [multiple]="true">
      <p-accordionTab
        [header]="process.name"
        *ngFor="let process of processFlow; let indexProcess = index"
      >
        <div class="card">
          <p-tabView>
            <p-tabPanel header="Items">
              <div class="timeline-container">
                <!-- <p>Status: {{ process.status }}</p>
    <p>Tipo: {{ process.type }}</p> -->
                <div class="timeline">
                  <svg
                    class="timeline-connector"
                    width="100%"
                    height="100%"
                    xmlns="http://www.w3.org/2000/svg"
                  ></svg>
                  <div
                    *ngFor="
                      let step of process.steps;
                      let indexProcessStep = index
                    "
                    class="timeline-item"
                    [attr.id]="'step-' + step.id"
                  >
                    <h3>{{ step.name }}</h3>
                    <ng-container *ngIf="checkDependency(indexProcess, step)">
                      <div class="card" style="box-shadow: 0 2px 3px #a19c00">
                        depende do passo:
                        {{
                          getStepById(indexProcess, step.dependencyStep ?? -1)
                            ?.name
                        }}
                      </div>
                    </ng-container>
                    <div *ngIf="step.items">
                      <div
                        class="card"
                        *ngFor="
                          let item of step.items;
                          let indexItemNote = index
                        "
                      >
                        <div class="ms-2">
                          <div>
                            <div class="row">
                              <div class="col-10">
                                <input
                                  type="checkbox"
                                  [disabled]="
                                    checkDependency(indexProcess, step) ||
                                    !canUpdate()
                                  "
                                  [checked]="item.isDone"
                                  (change)="updateCheckItem(step, item, $event)"
                                />

                                <span class="ms-2"
                                  ><strong>{{ item.name }}:</strong>
                                  {{ item.description }}</span
                                >
                              </div>
                              <div
                                class="col-1 align-self-center"
                                *appIsGranted="[
                                  'TOOLS_PROCESS_FLOW',
                                  'TOOLS_PROCESS_FLOW',
                                  'UPDATE'
                                ]"
                              >
                                <button
                                  class="btn btn-sm btn-primary"
                                  [disabled]="
                                    checkDependency(indexProcess, step) ||
                                    !canUpdate()
                                  "
                                  (click)="openAddNote(step.name + item.name!)"
                                >
                                  <i
                                    ngbTooltip="Adicionar nota sobre o item"
                                    class="fa fa-plus-square"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <ng-container
                            *ngIf="showSideBarAddNote(step.name + item.name!)"
                          >
                            <div class="btn-group" style="float: inline-end">
                              <button
                                (click)="closeAddNote()"
                                type="button"
                                class="btn btn-sm btn-danger"
                              >
                                Cancelar
                              </button>

                              <button
                                [disabled]="
                                  (noteText != null && noteText.length < 1) ||
                                  addNoteLoading
                                "
                                type="button"
                                class="btn btn-sm btn-success"
                                (click)="
                                  saveNote(
                                    indexProcess,
                                    indexProcessStep,
                                    indexItemNote,
                                    item
                                  )
                                "
                              >
                                <ng-container *ngIf="addNoteLoading">
                                  <div
                                    class="spinner-border text-primary m-1"
                                    role="status"
                                  >
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="!addNoteLoading">
                                  Salvar
                                </ng-container>
                              </button>
                            </div>
                            <p-editor
                              [style]="{ height: '320px' }"
                              [(ngModel)]="noteText"
                            >
                              <span class="ql-formats">
                                <select class="ql-font"></select>
                                <select class="ql-size"></select>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-bold"></button>
                                <button class="ql-italic"></button>
                                <button class="ql-underline"></button>
                                <button class="ql-strike"></button>
                              </span>
                              <span class="ql-formats">
                                <select class="ql-color"></select>
                                <select class="ql-background"></select>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-script" value="sub"></button>
                                <button
                                  class="ql-script"
                                  value="super"
                                ></button>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-header" value="1"></button>
                                <button class="ql-header" value="2"></button>
                                <button class="ql-blockquote"></button>
                                <button class="ql-code-block"></button>
                              </span>
                              <span class="ql-formats">
                                <button
                                  class="ql-list"
                                  value="ordered"
                                ></button>
                                <button class="ql-list" value="bullet"></button>
                                <button class="ql-indent" value="-1"></button>
                                <button class="ql-indent" value="+1"></button>
                              </span>
                              <span class="ql-formats">
                                <button
                                  class="ql-direction"
                                  value="rtl"
                                ></button>
                                <select class="ql-align"></select>
                              </span>
                              <span class="ql-formats">
                                <button class="ql-clean"></button> </span
                            ></p-editor>
                          </ng-container>
                          <div *ngIf="item.notes && item.notes.length > 0">
                            <p-scrollPanel
                              [style]="{
                                width: '100%',
                                height: '10 0px',
                                'background-color': '#fbfbc1'
                              }"
                              class="card"
                            >
                              <div *ngFor="let note of item.notes">
                                <div
                                  class="m-2"
                                  style="border-bottom: 1px solid lightgray"
                                >
                                  <div class="badge bg-primary">
                                    {{
                                      note.date | date : "dd-MM-yyy hh:mm:ss"
                                    }}
                                    - {{ note.userName ?? "" }}
                                  </div>

                                  <span [innerHTML]="note.note"></span>
                                </div>
                                <!--  -->
                              </div>
                            </p-scrollPanel>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Histórico">
              <ng-template pTemplate="header">
                <p-button
                  icon="fa fa-history ms-2"
                  (onClick)="getHistoryProcessFlow(process.id)"
                  [text]="true"
                  [loading]="historyProcessFlow['process' + process.id].loading"
                />
              </ng-template>
              <ng-template pTemplate="content">
                <p-scrollPanel
                  [style]="{
                    width: '100%',
                    height: '10 0px'
                  }"
                  class="card"
                >
                  <ng-container
                    *ngIf="
                      historyProcessFlow['process' + process.id].process
                        .length > 0;
                      else noHistory
                    "
                  >
                    <div
                      *ngFor="
                        let item of historyProcessFlow['process' + process.id]
                          .process
                      "
                    >
                      <div
                        class="m-2"
                        style="border-bottom: 1px solid lightgray"
                      >
                        <div class="badge bg-primary">
                          {{ item.date | date : "dd-MM-yyy hh:mm:ss" }}
                        </div>

                        <span>
                          {{ item.user }}: {{ item.processFlowStepName }} -
                          {{ item.processFlowStepItemName }} ->
                          {{ item.value }}</span
                        >
                      </div>
                      <!--  -->
                    </div>
                  </ng-container>
                  <ng-template #noHistory>
                    <div card="card-body text-center">
                      <span class="sr-only">Sem dados históricos</span>
                    </div>
                  </ng-template>
                </p-scrollPanel>
              </ng-template>
            </p-tabPanel>
          </p-tabView>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div *appIsGranted="['TOOLS_PROCESS_FLOW', 'TOOLS_PROCESS_FLOW', 'UPDATE']">
    <div id="tools_process_flow_update"></div>
  </div>
</div>
